import { curry } from 'ramda';
import { IAppState } from '../../redux';
import { IConfigState } from '../../redux/reducers';

type TSelectConfigValue = (<K extends keyof IConfigState>(key: K, state: IAppState) => IConfigState[K]) &
  (<K extends keyof IConfigState>(key: K) => (state: IAppState) => IConfigState[K]);

export const selectConfigValue = curry((key: keyof IConfigState, state: IAppState) => {
  return state.config[key];
}) as TSelectConfigValue;
